/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { getNotificationStatsOptions } from '../fn/cors/get-notification-stats-options';
import { GetNotificationStatsOptions$Params } from '../fn/cors/get-notification-stats-options';
import { notificationsByIdOptions } from '../fn/cors/notifications-by-id-options';
import { NotificationsByIdOptions$Params } from '../fn/cors/notifications-by-id-options';
import { notificationsOptions } from '../fn/cors/notifications-options';
import { NotificationsOptions$Params } from '../fn/cors/notifications-options';
import { notificationsTrashEmptyOptions } from '../fn/cors/notifications-trash-empty-options';
import { NotificationsTrashEmptyOptions$Params } from '../fn/cors/notifications-trash-empty-options';

@Injectable({ providedIn: 'root' })
export class CorsApiService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `notificationsOptions()` */
  static readonly NotificationsOptionsPath = '/notifications';

  /**
   * CORS support.
   *
   * Enable CORS by returning correct headers
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `notificationsOptions()` instead.
   *
   * This method doesn't expect any request body.
   */
  notificationsOptions$Response(params?: NotificationsOptions$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return notificationsOptions(this.http, this.rootUrl, params, context);
  }

  /**
   * CORS support.
   *
   * Enable CORS by returning correct headers
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `notificationsOptions$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  notificationsOptions(params?: NotificationsOptions$Params, context?: HttpContext): Observable<void> {
    return this.notificationsOptions$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `notificationsByIdOptions()` */
  static readonly NotificationsByIdOptionsPath = '/notification/{notificationId}';

  /**
   * CORS support.
   *
   * Enable CORS by returning correct headers
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `notificationsByIdOptions()` instead.
   *
   * This method doesn't expect any request body.
   */
  notificationsByIdOptions$Response(params: NotificationsByIdOptions$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return notificationsByIdOptions(this.http, this.rootUrl, params, context);
  }

  /**
   * CORS support.
   *
   * Enable CORS by returning correct headers
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `notificationsByIdOptions$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  notificationsByIdOptions(params: NotificationsByIdOptions$Params, context?: HttpContext): Observable<void> {
    return this.notificationsByIdOptions$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `getNotificationStatsOptions()` */
  static readonly GetNotificationStatsOptionsPath = '/notifications/stats';

  /**
   * CORS support.
   *
   * Enable CORS by returning correct headers
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getNotificationStatsOptions()` instead.
   *
   * This method doesn't expect any request body.
   */
  getNotificationStatsOptions$Response(params?: GetNotificationStatsOptions$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return getNotificationStatsOptions(this.http, this.rootUrl, params, context);
  }

  /**
   * CORS support.
   *
   * Enable CORS by returning correct headers
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getNotificationStatsOptions$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getNotificationStatsOptions(params?: GetNotificationStatsOptions$Params, context?: HttpContext): Observable<void> {
    return this.getNotificationStatsOptions$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `notificationsTrashEmptyOptions()` */
  static readonly NotificationsTrashEmptyOptionsPath = '/notifications/trash/empty';

  /**
   * CORS support.
   *
   * Enable CORS by returning correct headers
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `notificationsTrashEmptyOptions()` instead.
   *
   * This method doesn't expect any request body.
   */
  notificationsTrashEmptyOptions$Response(params?: NotificationsTrashEmptyOptions$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return notificationsTrashEmptyOptions(this.http, this.rootUrl, params, context);
  }

  /**
   * CORS support.
   *
   * Enable CORS by returning correct headers
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `notificationsTrashEmptyOptions$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  notificationsTrashEmptyOptions(params?: NotificationsTrashEmptyOptions$Params, context?: HttpContext): Observable<void> {
    return this.notificationsTrashEmptyOptions$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
